/** true se o valor casar com E.164 canônico */
export function isValidE164(value) {
    return typeof value === 'string' && /^\+[1-9]\d{7,14}$/.test(value);
}

/**
 * Exibição legível para tabelas / telas de detalhe.
 * - null/vazio           → ""
 * - +55 + 11 dígitos     → "(11) 98765-4321"
 * - +55 + 10 dígitos     → "(11) 3456-7890"
 * - outro + inicial      → devolve como está (estrangeiro)
 * - qualquer outra coisa → devolve o valor CRU (nunca mascarar lixo)
 */
export function formatPhoneForDisplay(value) {
    if (!value) return '';
    const digits = value.replace(/\D/g, '');
    if (value.startsWith('+55')) {
        if (digits.length === 13) {
            return `(${digits.slice(2, 4)}) ${digits.slice(4, 9)}-${digits.slice(9)}`;
        }
        if (digits.length === 12) {
            return `(${digits.slice(2, 4)}) ${digits.slice(4, 8)}-${digits.slice(8)}`;
        }
    }
    if (value.startsWith('+')) return value;
    return value;
}

/**
 * Converte um número E.164 brasileiro para o formato do InputMask correspondente.
 * - maskType 'mobile' espera 11 dígitos locais → "(11)98765-4321"
 * - maskType 'phone'  espera 10 dígitos locais → "(11)3456-7890"
 * Valores não-E164 ou estrangeiros são devolvidos sem alteração.
 */
export function e164ToMasked(value, maskType) {
    if (!value) return '';
    if (!isValidE164(value) || !value.startsWith('+55')) return value;
    const local = value.slice(3); // remove "+55"
    if (maskType === 'mobile' && local.length === 11) {
        return `(${local.slice(0, 2)})${local.slice(2, 7)}-${local.slice(7)}`;
    }
    if (maskType === 'phone' && local.length === 10) {
        return `(${local.slice(0, 2)})${local.slice(2, 6)}-${local.slice(6)}`;
    }
    return local;
}

/**
 * Remove a máscara antes de enviar à API.
 * Preserva "+" inicial se presente.
 */
export function stripMask(value) {
    if (!value) return '';
    const hasPlus = value.startsWith('+');
    const digits = value.replace(/\D/g, '');
    return hasPlus ? '+' + digits : digits;
}
